<template>
  <form class="k-form signUp findIdComplete" id="signupForm" @submit.prevent="onSubmit()">
    <p class="etext mt25" v-if="userId === null"> 입력하신 정보와 일치하는 아이디가 없습니다.</p>
    <p class="etext mt25" v-else> 입력하신 정보와 일치하는 아이디 정보입니다. </p>
    <fieldset>
      <p class="fem">{{userId}}</p>
      <p class="lnote" v-if="userId !== null">
        <span class="k-icon k-i-warning"></span>
        개인정보보호를 위해 아이디 뒷자리는 ***로 표시됩니다.</p>
      <input type="submit" v-if="userId !== null" value= "로그인 하기" class="mid_btn orange login_btn mt25">
      <input type="submit" v-else value= "처음으로" class="mid_btn orange login_btn mt25">
    </fieldset>
  </form>
</template>

<script>
export default {
  name: 'FindIdComplete',
  props: [
    'param'
  ],
  data () {
    return {
      userId: null,
    }
  },
  created () {
    const id = this.param.userId
    this.userId = id
    // this.userId = id.substring(0, 4).padEnd(id.length, '*')
  },
  methods: {
    onSubmit () {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>
